import React, { useState, useEffect, useRef } from "react";
import {
    FaHome,
    FaWallet,
    FaAddressCard,
    FaChevronRight,
    FaHeadset,
    FaUsersCog,
    FaDoorOpen,
} from "react-icons/fa";
import { FaUserCircle, FaChevronDown, FaSearch } from "react-icons/fa";
import logo from "../images/logo.png";
import egam from "../images/egam.png";
import "../css/cabecalho.css";
import { Link, useLocation } from "react-router-dom";
import { NavDropdown } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { formatCNPJ, formatCodigoCliente } from "../../utils/format";
import { filtrarClientes } from "../../utils/buscaCliente";
import { temModulo as temModuloAtivo } from "../../utils/acesso";

function Header({ cliente, clientesPerfis, onTrocarCliente, onLogout, souMaster, modulosAtivos, ehMultiAcesso }) {
    const navigate = useNavigate();
    const location = useLocation();
    const [activeButton, setActiveButton] = useState("Inicio");
    const [seletorAberto, setSeletorAberto] = useState(false);
    const [buscaCliente, setBuscaCliente] = useState("");
    const seletorRef = useRef(null);

    const temSeletorCliente = Array.isArray(clientesPerfis) && clientesPerfis.length > 1;
    const clientesFiltrados = temSeletorCliente ? filtrarClientes(clientesPerfis, buscaCliente) : [];

    useEffect(() => {
        if (!seletorAberto) {
            return;
        }

        const fecharAoClicarFora = (event) => {
            if (seletorRef.current && !seletorRef.current.contains(event.target)) {
                setSeletorAberto(false);
            }
        };

        document.addEventListener("mousedown", fecharAoClicarFora);
        return () => document.removeEventListener("mousedown", fecharAoClicarFora);
    }, [seletorAberto]);

    const handleSelecionarCliente = (cdCliente) => {
        setSeletorAberto(false);
        setBuscaCliente("");
        if (onTrocarCliente) {
            onTrocarCliente(cdCliente);
        }
    };

    // ===========================================================
    // CONTROLE DE FUNCIONALIDADE (FEATURE FLAG)
    // Mude para true para ativar o menu de Feedback
    // ===========================================================
    const FEATURE_FEEDBACK_ATIVO = false;

    useEffect(() => {
        if (location.pathname === "/boletos" || location.pathname === "/danfe") {
            setActiveButton("Financeiro");
        } else if (location.pathname === "/dados-cadastrais") {
            setActiveButton("Dados cadastrais");
        } else if (location.pathname === "/") {
            setActiveButton("Inicio");
        }
    }, [location.pathname]);

    const handleButtonClick = (buttonName) => {
        setActiveButton(buttonName);
    };

    const handleSacButtonClick = (route, state = {}) => {
        handleButtonClick("SAC");
        navigate(route, { state });
    };

    const redirectToEGAM = () => {
        window.location.href = "https://www.egam.com.br/egam/";
    };

    const redirectToLogin = () => {
            if (onLogout) {
                onLogout();
            }
        };

    const handleSelectChange = (event) => {
        const selectedValue = event.target.value;

        switch (selectedValue) {
            case "boletos":
                navigate("/boletos");
                break;
            case "danfe":
                navigate("/danfe");
                break;
            default:
                break;
        }
    };

    const temAcessoAoSAC = () => {
        //return clientesAutorizadosSAC.includes(parseInt(cliente.cdCliente));
        return true;
    };

    const temModulo = (nomeModulo) => temModuloAtivo(modulosAtivos, nomeModulo);

    return (
        <header className="header">
            <div className="topo">
                <div className="header-left">
                    <img src={logo} alt="Logo" className="logo" />
                    <h2 className="bem-vindo">Bem-vindo(a) de volta!</h2>
                </div>

                <div className="header-right seletor-cliente-wrapper" ref={seletorRef}>
                    <button
                        className="minha-farmacia"
                        onClick={temSeletorCliente ? () => setSeletorAberto((aberto) => !aberto) : undefined}
                        title={cliente.razaoSocial}
                    >
                        <FaUserCircle size={22} className="icon" />
                        <span className="farmacia-nome">
                            {cliente.razaoSocial}
                        </span>
                        <FaChevronDown size={16} className="chevron" />
                    </button>

                    {temSeletorCliente && seletorAberto && (
                        <div className="seletor-cliente-menu">
                            <div className="seletor-cliente-busca">
                                <FaSearch size={14} />
                                <input
                                    type="text"
                                    placeholder="Buscar por nome, código ou CNPJ..."
                                    value={buscaCliente}
                                    onChange={(event) => setBuscaCliente(event.target.value)}
                                    autoFocus
                                />
                            </div>
                            {clientesFiltrados.length === 0 ? (
                                <p className="seletor-cliente-vazio">Nenhum cliente encontrado.</p>
                            ) : (
                                clientesFiltrados.map((item) => (
                                    <button
                                        key={item.cdCliente}
                                        className={`seletor-cliente-item ${String(item.cdCliente) === String(cliente.cdCliente) ? "is-active" : ""}`}
                                        onClick={() => handleSelecionarCliente(item.cdCliente)}
                                    >
                                        <span className="seletor-cliente-item-nome">{item.nmCliente}</span>
                                        <span className="seletor-cliente-item-detalhe">
                                            Código: {formatCodigoCliente(item.cdCliente, item.digitoCliente)} • CNPJ: {formatCNPJ(item.dsCnpjCpf)}
                                        </span>
                                    </button>
                                ))
                            )}
                        </div>
                    )}
                </div>

                <div className="cnpj-codigo">
                    <span className="cnpj">CNPJ: {formatCNPJ(cliente.cnpj)}</span>
                    <span className="separator">•</span>
                    <span className="codigo">
                        Código: {cliente.cdCliente}-{cliente.digitoCliente}
                    </span>
                </div>

                <div className="header-right">
                    <button className="sair-button" onClick={redirectToLogin} title="Sair" aria-label="Sair">
                        <FaDoorOpen size={20} className="sair-icon" />
                    </button>
                </div>
            </div>

            <div className="navegacao-barra">
                <div className="navegacao">
                    <button
                        className={`nav-item ${activeButton === "Inicio" ? "active" : ""
                            }`}
                        onClick={() => handleButtonClick("Inicio")}
                    >
                        <FaHome size={18} className="nav-icon" />
                        <Link to="/" className="nav-item-info">
                            <span>Inicio</span>
                        </Link>
                    </button>
                    {temModulo("Financeiro") && (
                        <NavDropdown
                            title={
                                <span>
                                    <FaWallet size={18} className="nav-icon" />
                                    <span className="span">Financeiro</span>
                                </span>
                            }
                            id="navbarScrollingDropdown"
                            className={`nav-item ${activeButton === "Financeiro" ? "active" : ""}`}
                            onClick={() => handleButtonClick("Financeiro")}
                            onSelect={() => handleButtonClick("Financeiro")}
                        >
                            {ehMultiAcesso && (
                                <NavDropdown.Item
                                    as="button"
                                    onClick={() => {
                                        handleButtonClick("Financeiro");
                                        navigate("/resumo");
                                    }}
                                >
                                    Resumo
                                </NavDropdown.Item>
                            )}
                            <NavDropdown.Item
                                as="button"
                                onClick={() => {
                                    handleButtonClick("Financeiro");
                                    navigate("/boletos", {
                                        state: { situacaoIn: ["AVENCER"] },
                                    });
                                }}
                            >
                                Boleto
                            </NavDropdown.Item>
                            <NavDropdown.Item
                                as={Link}
                                to="/danfe"
                                onClick={() => handleButtonClick("Financeiro")}
                            >
                                Danfe / XML
                            </NavDropdown.Item>
                        </NavDropdown>
                    )}

                    {temAcessoAoSAC() && temModulo("SAC") && (
                        <NavDropdown
                            title={
                                <span>
                                    <FaHeadset size={18} className="nav-icon" />
                                    <span className="span">SAC</span>
                                </span>
                            }
                            id="sac-dropdown"
                            className={`nav-item ${activeButton === "Sac" ? "active" : ""}`}
                            onClick={() => handleButtonClick("Sac")}
                            onSelect={() => handleButtonClick("Sac")}
                        >
                            <NavDropdown.Item
                                as="button"
                                title="Utilize para: Avaria, Defeito de Fábrica, Recall, Vencimento Curto, Erro de Preço ou Mercadoria Errada."
                                onClick={() => {
                                    handleButtonClick("Sac");
                                    navigate("/registro-sac", {
                                        state: { tipoOcorrencia: 'DEVOLUCAO' },
                                    });
                                }}
                            >
                                Registrar Devolução
                            </NavDropdown.Item>
                            <NavDropdown.Item
                                as="button"
                                title="Utilize para: Quando faltou algum produto na caixa ou quando recebeu mercadoria a mais/errada."
                                onClick={() => {
                                    handleButtonClick("Sac");
                                    navigate("/registro-sac", {
                                        state: { tipoOcorrencia: 'SOBRA_MERCADORIA' },
                                    });
                                }}
                            >
                                Registrar Falta e/ou Sobra
                            </NavDropdown.Item>
                            <NavDropdown.Item
                                as="button"
                                title="Utilize para: Cartas de Correção (Lote, Validade, Nota)."
                                onClick={() => {
                                    handleButtonClick("Sac");
                                    navigate("/registro-sac", {
                                        state: { tipoOcorrencia: 'SOLICITACAO' },
                                    });
                                }}
                            >
                                Registrar Solicitação
                            </NavDropdown.Item>

                            <NavDropdown.Item
                                as="button"
                                title="Veja o status, protocolos e o histórico de todas as suas ocorrências registradas."
                                onClick={() => handleSacButtonClick("/consulta-sac")}
                                className="consulta-btn"
                            >
                                Consultar Ocorrências
                            </NavDropdown.Item>

                            {/* ================================================== */}
                            {/* NOVA FUNCIONALIDADE DE FEEDBACK (CONTROLADA POR FLAG) */}
                            {/* ================================================== */}
                            {FEATURE_FEEDBACK_ATIVO && (
                                <>
                                    <NavDropdown.Divider />
                                    <NavDropdown.Item
                                        as="button"
                                        onClick={() => {
                                            handleButtonClick("Sac");
                                            navigate("/registro-feedback"); // Criar Rota
                                        }}
                                    >
                                        Enviar Feedback
                                    </NavDropdown.Item>
                                    <NavDropdown.Item
                                        as="button"
                                        onClick={() => {
                                            handleButtonClick("Sac");
                                            navigate("/consulta-feedback"); // Criar Rota
                                        }}
                                    >
                                        Consultar Feedback
                                    </NavDropdown.Item>
                                </>
                            )}
                            {/* FIM DO BLOCO DE FEEDBACK */}

                        </NavDropdown>
                    )}

                    {temModulo("Dados Cadastrais") && (
                        <button
                            className={`nav-item ${activeButton === "Dados cadastrais" ? "active" : ""
                                }`}
                            onClick={() => handleButtonClick("Dados cadastrais")}
                        >
                            <FaAddressCard size={18} className="nav-icon" />
                            <Link to="/dados-cadastrais" className="nav-item-info">
                                Dados cadastrais
                            </Link>
                        </button>
                    )}

                    {souMaster && (
                        <button
                            className={`nav-item ${activeButton === "Usuários e Permissões" ? "active" : ""}`}
                            onClick={() => handleButtonClick("Usuários e Permissões")}
                        >
                            <FaUsersCog size={18} className="nav-icon" />
                            <Link to="/gestao-usuarios" className="nav-item-info">
                                Usuários e Permissões
                            </Link>
                        </button>
                    )}

                </div>

                <div className="egam-section">
                    <button className="egam-button" onClick={redirectToEGAM}>
                        <img src={egam} alt="eGAM Logo" className="egam-logo" />
                        <span>eGAM</span>
                        <FaChevronRight size={16} className="chevron" />
                    </button>
                </div>
            </div>
        </header>
    );
}

export default Header;
